import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const UnmuteIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M15.9288 7.96216C16.4449 8.47805 16.8542 9.09056 17.1335 9.76468C17.4128 10.4388 17.5565 11.1613 17.5565 11.891C17.5565 12.6207 17.4128 13.3433 17.1335 14.0174C16.8542 14.6915 16.4449 15.304 15.9288 15.8199M19.071 4.81995C19.9996 5.74853 20.7362 6.85092 21.2388 8.06418C21.7413 9.27744 22 10.5778 22 11.891C22 13.2043 21.7413 14.5046 21.2388 15.7179C20.7362 16.9311 19.9996 18.0335 19.071 18.9621M4.87332 15.2243H3.11111C2.81642 15.2243 2.53381 15.1073 2.32544 14.8989C2.11706 14.6905 2 14.4079 2 14.1132V9.66882C2 9.37413 2.11706 9.09152 2.32544 8.88314C2.53381 8.67477 2.81642 8.55771 3.11111 8.55771H4.87332L10.1033 3.32773C10.8033 2.62774 12 3.12329 12 4.11328V19.6688C12 20.6588 10.8033 21.1543 10.1033 20.4543L4.87332 15.2243Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

UnmuteIcon.displayName = 'UnmuteIcon';
